// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gKKw","title":"styles_title__2SdFW"};